(function ($, window) {
  "use strict";

  var amberJeanJs = {

    m: function () {
      this.d();
      this.methods();
    },

    d: function () {
      this._window = $(window);
      this._document = $(document);
      this._body = $("body");
      this._html = $("html");
    },

    methods: function () {
    
      this.slickActivation();
      this.scrollAnimations();
      this.gsapInit();
      // this.featureReveal();
 
      this.mobileMenu();
      this.headerSticky();
      this.videoControls();
      this.heroContent();
      this.accordiyanActivation();
      // this.productRightSticky();
      // this.tabActivation();
      this.productPopupActivation();
      this.productModalActivation();
      this.dropdownActivation();
      this.dotAnimationActivation();
      this.lottieSignatureInit();
      this.externalLinksHandler();
      // this.consultationTabActivation();
    },

    /**
     * GSAP Initialization
     */
    gsapInit: function () {
      // Register ScrollTrigger plugin
      if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);
        
        // GSAP animation for each instance of .slide-up class
        // Stagger animation for all .slide-up elements that are next to each other in the DOM
        // Find all .slide-up elements, group consecutive siblings, and animate each group with stagger
        (function() {
          var all = Array.from(document.querySelectorAll('.slide-up'));
          var groups = [];
          var currentGroup = [];

          function areSiblings(a, b) {
            return a.parentElement === b.parentElement &&
                   a.nextElementSibling === b;
          }

          for (var i = 0; i < all.length; i++) {
            if (currentGroup.length === 0) {
              currentGroup.push(all[i]);
            } else {
              var prev = currentGroup[currentGroup.length - 1];
              if (areSiblings(prev, all[i])) {
                currentGroup.push(all[i]);
              } else {
                groups.push(currentGroup);
                currentGroup = [all[i]];
              }
            }
          }
          if (currentGroup.length) groups.push(currentGroup);

          groups.forEach(function(group) {
            if (group.length > 0) {
              // Check if elements are in a flex column-reverse container
              var triggerElement = group[0];
              var parent = group[0].parentElement;
              var isColumnReverse = false;
              
              if (parent) {
                var computedStyle = window.getComputedStyle(parent);
                isColumnReverse = computedStyle.flexDirection === 'column-reverse';
              }
              
              // For column-reverse, use the last element as trigger since it appears first visually
              if (isColumnReverse && group.length > 1) {
                triggerElement = group[group.length - 1];
              }
              
              // Check if any elements in the group have custom delays
              var hasCustomDelays = group.some(function(el) {
                return el.hasAttribute('data-delay');
              });

              if (hasCustomDelays) {
                // Create individual animations with custom delays
                var tl = gsap.timeline({
                  scrollTrigger: {
                    trigger: triggerElement,
                    start: 'top 50%',
                    end: 'bottom 0%',
                    toggleActions: 'play none none reverse'
                  }
                });

                group.forEach(function(element, index) {
                  var customDelay = parseFloat(element.getAttribute('data-delay')) || 0;
                  var staggerDelay = (isColumnReverse ? (group.length - 1 - index) : index) * 0.2;
                  var totalDelay = customDelay + staggerDelay;

                  tl.fromTo(element,
                    { opacity: 0, y: 30 },
                    {
                      opacity: 1,
                      y: 0,
                      duration: .4,
                      ease: "power2.out"
                    },
                    totalDelay
                  );
                });
              } else {
                // Use the original stagger animation for groups without custom delays
                gsap.fromTo(group,
                  { opacity: 0, y: 30 },
                  {
                    opacity: 1,
                    y: 0,
                    duration: .4,
                    stagger: isColumnReverse ? -0.2 : 0.2,
                    scrollTrigger: {
                      trigger: triggerElement,
                      start: 'top 90%',
                      end: 'bottom 20%',
                      toggleActions: 'play none none reverse'
                    }
                  }
                );
              }
            }
          });
        })();
         // Animate .journey-way__desk-border-line from x -100% to 100% as window is scrolled down
         /*document.querySelectorAll('.journey-way__desk-border-line').forEach(function(line) {
           gsap.fromTo(line, 
             { xPercent: -100 }, 
             { 
               xPercent: 100,
               ease: "none",
               scrollTrigger: {
                 trigger: line,
                 start: "top 70%",
                 end: "bottom 10%",
                 scrub: true
               }
             }
           );
         });
         document.querySelectorAll('.journey-way__mobi-border-line').forEach(function(line) {
          gsap.fromTo(line, 
            { yPercent: -100 }, 
            { 
              yPercent: 100,
              ease: "none",
              scrollTrigger: {
                trigger: line,
                start: "top 70%",
                end: "bottom 10%",
                scrub: true
              }
            }
          );
        });*/
        
        // Stagger animation system for .stagger-anim elements
        // Use GSAP timeline with stagger to ensure 1-by-1 animation
        (function() {
          var staggerElements = Array.from(document.querySelectorAll('.stagger-anim'));
          var staggerGroups = [];
          var currentGroup = [];

          function areSiblings(a, b) {
            return a.parentElement === b.parentElement &&
                   a.nextElementSibling === b;
          }

          // Group consecutive sibling elements
          for (var i = 0; i < staggerElements.length; i++) {
            if (currentGroup.length === 0) {
              currentGroup.push(staggerElements[i]);
            } else {
              var prev = currentGroup[currentGroup.length - 1];
              if (areSiblings(prev, staggerElements[i])) {
                currentGroup.push(staggerElements[i]);
              } else {
                staggerGroups.push(currentGroup);
                currentGroup = [staggerElements[i]];
              }
            }
          }
          if (currentGroup.length) staggerGroups.push(currentGroup);

          staggerGroups.forEach(function(group) {
            if (group.length > 0) {
              // Check if elements are in a flex column-reverse container
              var triggerElement = group[0];
              var parent = group[0].parentElement;
              var isColumnReverse = false;
              
              if (parent) {
                var computedStyle = window.getComputedStyle(parent);
                isColumnReverse = computedStyle.flexDirection === 'column-reverse';
              }
              
              // For column-reverse, use the last element as trigger since it appears first visually
              if (isColumnReverse && group.length > 1) {
                triggerElement = group[group.length - 1];
              }

              // Create a timeline for staggered animations
              var tl = gsap.timeline({
                scrollTrigger: {
                  trigger: triggerElement,
                  start: 'top 80%',
                  end: 'bottom 20%',
                  toggleActions: 'play none none reverse'
                }
              });

              // Animate each element individually with proper timing
              group.forEach(function(element, index) {
                var fromVars = {};
                var toVars = {
                  duration: 0.5,
                  ease: "power2.out"
                };

                // Set up animation properties based on element classes
                if (element.classList.contains('text-up')) {
                  fromVars.opacity = 0;
                  fromVars.y = 30;
                  toVars.opacity = 1;
                  toVars.y = 0;
                } else if (element.classList.contains('line-x')) {
                  // Instead of animating, add a class to trigger CSS transition
                  tl.call(function() {
                    element.classList.remove('visible');
                  }, null, delay)
                  .call(function() {
                    element.classList.add('visible');
                  }, null, "+=0.01"); // Remove 'visible' when timeline reverses
                  // Skip the default GSAP fromTo for this element
                  return;
                
                } else if (element.classList.contains('line-y')) {
                   // Instead of animating, add a class to trigger CSS transition
                   tl.call(function() {
                    element.classList.remove('visible');
                  }, null, delay)
                  .call(function() {
                    element.classList.add('visible');
                  }, null, "+=0.01"); // Remove 'visible' when timeline reverses
                  // Skip the default GSAP fromTo for this element
                  return;
                
                } else {
                  // Default animation (similar to slide-up)
                  fromVars.opacity = 0;
                  fromVars.y = 30;
                  toVars.opacity = 1;
                  toVars.y = 0;
                }

                // Calculate delay based on position and column-reverse
                var actualIndex = isColumnReverse ? (group.length - 1 - index) : index;
                var delay = actualIndex * 0.5;

                // Add to timeline with specific delay
                tl.fromTo(element, fromVars, toVars, delay);
              });
            }
          });
        })();
        
         // Parallax effect for .parallax-up elements
         document.querySelectorAll('.parallax-up').forEach(function(element) {
           gsap.to(element, {
             y: -50,
             ease: "none",
             scrollTrigger: {
               trigger: element,
               start: "top bottom",
               end: "bottom top",
               scrub: true
             }
           });
         });
         document.querySelectorAll('.parallax-down').forEach(function(element) {
          var isSmallMobile = window.matchMedia("(max-width: 1023px)").matches;
           // For small mobile, start fade out later (e.g., 10% from top), otherwise use 30%
           var startValue = isSmallMobile ? "top 5%" : "top 20%";
          gsap.to(element, {
            y: 50,
            ease: "none",
            scrollTrigger: {
              trigger: element,
              start: isSmallMobile,
              end: "bottom top",
              scrub: true
            }
          });
        });
         document.querySelectorAll('.fade-out-scroll').forEach(function(element) {
           // Check if device width is less than 480px
           var isSmallMobile = window.matchMedia("(max-width: 1023px)").matches;
           // For small mobile, start fade out later (e.g., 10% from top), otherwise use 30%
           var startValue = isSmallMobile ? "top 5%" : "top 20%";
           gsap.fromTo(
             element,
             { opacity: 1 },
             {
               opacity: 0,
               ease: "none",
               scrollTrigger: {
                 trigger: element,
                 start: startValue,
                 end: "bottom top",
                 scrub: true
               }
             }
           );
         });
         

       } else {
        //  console.warn('GSAP or ScrollTrigger not loaded');
       } 
    },

    /**
     * Slick sliders
     */
    slickActivation: function () {
      var $window = $(window);
      var autoplaySpeed = 5000;
      var isMobile = window.matchMedia("(max-width: 1024px)").matches;
      // ---------------- Announcement Bar Slider ----------------
      if ($(".announcement__inner").length > 0) {
        $(".announcement__inner").slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: autoplaySpeed,
          arrows: true,
          dots: false,
          vertical: true,
          fade: false,
          speed: 500,
          pauseOnHover: false
        });
      }
      // ---------------- Best Seller Slider ----------------
      $(".best-seller__items").slick({
        infinite: true,
        slidesToShow: 4,
        arrows: false,
        responsive: [
          { breakpoint: 1024, settings: { slidesToShow: 1 } }
        ]
      });
      // if ($(Window).width() < 768) {
      //   $(document).ready(function () {
      //     if ($(".best-seller__inner_shop .best-seller__items").hasClass("slick-initialized")) {
      //       $(".best-seller__inner_shop .best-seller__items").slick("unslick");
      //     }
      //   });
      // }
      // Custom navigation arrows for Best Seller Slider
      $(document).on('click', '.best-seller-next-arrow', function () {
        var $slider = $(this).closest('.best-seller').find('.best-seller__items');
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('slickNext');
        }
      });
      $(document).on('click', '.best-seller-prev-arrow', function () {
        var $slider = $(this).closest('.best-seller').find('.best-seller__items');
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('slickPrev');
        }
      });
      // ---------------- Features Slider (Mobile Only) ----------------
      function initFeatureSlider() {
        if ($window.width() < 1024) {
          if (!$('.feature__items').hasClass('slick-initialized')) {
            $('.feature__items').slick({ slidesToShow: 1, slidesToScroll: 1, arrows: false });
          }
        } else {
          if ($('.feature__items').hasClass('slick-initialized')) {
            $('.feature__items').slick('unslick');
          }
        }
      }
      initFeatureSlider();
      $(document).on('click', '.feature-next-arrow', function () {
        var $slider = $(this).closest('.feature').find('.feature__items');
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('slickNext');
        }
      });
      $(document).on('click', '.feature-prev-arrow', function () {
        var $slider = $(this).closest('.feature').find('.feature__items');
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('slickPrev');
        }
      });
      // ---------------- Seen In Slider (Mobile Only) ----------------
      function initSeenInSlider() {
        if ($window.width() < 1024) {
          if (!$(".seenin__items").hasClass('slick-initialized')) {
            $(".seenin__items").slick({
              infinite: true,
              autoplay: true,
              autoplaySpeed: 0,
              speed: 5000,
              cssEase: "linear",
              variableWidth: true,
              arrows: false,
              pauseOnHover: false,
              // rtl: true
            });
          }
        } else {
          if ($(".seenin__items").hasClass('slick-initialized')) {
            $(".seenin__items").slick('unslick');
          }
        }
      }
      initSeenInSlider();
      // ---------------- Story Content Slider (Parent) ----------------
      function initStoryContent() {
        if ($window.width() < 1024) {
          if (!$('.story__content').hasClass('slick-initialized')) {
            $('.story__content').slick({ 
              slidesToShow: 1, 
              slidesToScroll: 1, 
              arrows: false, 
              autoplay: false,
              draggable: true,
              swipe: true,
              touchMove: true,
              fade: false,
              speed: 300,
              responsive: [
                { breakpoint: 1024, settings: { slidesToShow: 3 } },
                { breakpoint: 768, settings: { slidesToShow: 2 } },
                { breakpoint: 480, settings: { slidesToShow: 1 } }
              ]
            });
          }
        } else {
          if ($('.story__content').hasClass('slick-initialized')) {
            $('.story__content').slick('unslick');
          }
        }
      }
      initStoryContent();
      // ---------------- Story Items Slider (Child) ----------------
      if($('.story__items_slider').length > 0) {
        $('.story__items_slider').each(function () {
          var $slider = $(this);
          $slider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            autoplay: false,
            autoplaySpeed: autoplaySpeed,
            draggable: false,
            swipe: false,
            touchMove: false,
            lazyLoad: 'ondemand'
          });
          // --- Dot Fill Animation Logic ---
          $slider.on('afterChange', function (event, slick, currentSlide) {
            var $dots = $slider.find('.slick-dots li');
            $dots.removeClass('filled active-dot-animate');
            $dots.each(function (index) {
              if (index < currentSlide) $(this).addClass('filled');
            });
            if (slick.options.autoplay) {
              $dots.eq(currentSlide).addClass('active-dot-animate');
            }
          });
          // --- Desktop Hover Autoplay & Video Handling ---
          if (!isMobile) {
            var $hoverTarget = $slider.closest('.story__items-wrap');
            function startAutoplay() {
              if (!$slider.slick('slickGetOption', 'autoplay')) {
                $slider.slick('slickSetOption', 'autoplay', true, true);
              }
              $slider.slick('slickPlay');
              $slider.find('.slick-dots li.slick-active').addClass('active-dot-animate');
              $slider.find('.slick-slide.slick-active video').each(function () {
                this.setAttribute('autoplay', 'autoplay');
                this.play();
              });
            }
            function stopAutoplay() {
              $slider.slick('slickPause');
              $slider.find('.slick-dots li').removeClass('active-dot-animate');
              $slider.find('video').each(function () {
                this.pause();
                this.removeAttribute('autoplay');
                this.currentTime = 0;
              });
            }
            $hoverTarget.on('mouseover', function () {
              startAutoplay();
            });
            $hoverTarget.on('mouseout', function (e) {
              if (!$(e.relatedTarget).closest($hoverTarget).length) {
                stopAutoplay();
              }
            });
          }
          // Reset dot animation before slide changes
          // $slider.on('beforeChange', function () {
          //   $slider.find('.slick-dots li').removeClass('active-dot-animate');
          // });
        });
      }
      // ---------------- Mobile Specific Story Autoplay ----------------
      if (isMobile) {
        $('.story__content').on('afterChange', function () {
          $('.story__items-wrap').each(function () {
            var $wrap = $(this);
            var $childSlider = $wrap.find('.story__items');
            
            // Check if child slider is initialized before calling slick methods
            if ($childSlider.hasClass('slick-initialized')) {
              if ($wrap.hasClass('slick-current') && $wrap.hasClass('slick-active')) {
                $childSlider.slick('slickPlay');
                $childSlider.find('.slick-dots li.slick-active').addClass('active-dot-animate');
                // Play videos in active child slider
                $childSlider.find('.slick-slide.slick-active video').each(function () {
                  this.setAttribute('autoplay', 'autoplay');
                  this.play();
                });
              } else {
                $childSlider.slick('slickPause');
                $childSlider.find('.slick-dots li').removeClass('active-dot-animate');
                // Pause inactive videos
                $childSlider.find('video').each(function () {
                  this.pause();
                  this.removeAttribute('autoplay');
                  this.currentTime = 0;
                });
              }
            } else {
              // Handle video playback for non-slider items
              if ($wrap.hasClass('slick-current') && $wrap.hasClass('slick-active')) {
                // Play videos in active item
                $childSlider.find('video').each(function () {
                  this.setAttribute('autoplay', 'autoplay');
                  this.play();
                });
              } else {
                // Pause inactive videos
                $childSlider.find('video').each(function () {
                  this.pause();
                  this.removeAttribute('autoplay');
                  this.currentTime = 0;
                });
              }
            }
          });
        });
        // Initialize mobile sliders and video autoplay
        $('.story__items-wrap').each(function () {
          var $wrap = $(this);
          var $childSlider = $wrap.find('.story__items');
          
          // Check if slider is initialized before calling slick methods
          if ($childSlider.hasClass('slick-initialized')) {
            if ($wrap.hasClass('slick-current') && $wrap.hasClass('slick-active')) {
              $childSlider.slick('slickPlay');
              $childSlider.find('.slick-dots li.slick-active').addClass('active-dot-animate');
              $childSlider.find('.slick-slide.slick-active video').each(function () {
                this.setAttribute('autoplay', 'autoplay');
                this.play();
              });
            } else {
              $childSlider.slick('slickPause');
              $childSlider.find('.slick-dots li').removeClass('active-dot-animate');
              $childSlider.find('video').each(function () {
                this.pause();
                this.removeAttribute('autoplay');
                this.currentTime = 0;
              });
            }
          }
        });
      }
      // ---------------- Global Story Slider Arrows ----------------
      $(document).on('click', '.story-next-arrow', function () {
        var $slider = $(this).closest('.story__items-wrap').find('.story__items');
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('slickNext');
        }
      });
      $(document).on('click', '.story-prev-arrow', function () {
        var $slider = $(this).closest('.story__items-wrap').find('.story__items');
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('slickPrev');
        }
      });
      // ---------------- Responsive Handling ----------------
      $window.on('resize', function () {
        initFeatureSlider();
        initSeenInSlider();
        initStoryContent();
      });
      if($('.product__left-items-slider').length > 0){
        $('.product__left-items-slider').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          variableWidth: true,
          adaptiveHeight: false,
        });
        $('.product__slider-left').click(function () {
          var $slider = $(this).parent().parent().find('.slick-slider');
          if ($slider.hasClass('slick-initialized')) {
            $slider.slick('slickPrev');
          }
        });
        $('.product__slider-right').click(function () {
          var $slider = $(this).parent().parent().find('.slick-slider');
          if ($slider.hasClass('slick-initialized')) {
            $slider.slick('slickNext');
          }
        });
        /*
        function resizeMediaSlider() {
          const slider = document.querySelector('.product__left-items-slider');
          if (!slider) return;
        
          // Calculate max allowed dimensions
          const maxHeight = window.innerHeight * 0.95;
          const maxWidth = window.innerWidth;
        
          slider.style.maxHeight = `${maxHeight}px`;
          slider.style.maxWidth = `${maxWidth}px`;
        
          // Update each slide item
          const slides = slider.querySelectorAll('img, video');
          slides.forEach(el => {
            el.style.maxHeight = `${maxHeight}px`;
            el.style.maxWidth = `${maxWidth}px`;
          });
        }
        
        // Run on load and resize
        window.addEventListener('load', resizeMediaSlider);
        window.addEventListener('resize', resizeMediaSlider);
        */
      }

      $(".marquee__items").slick({
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 2000,
        variableWidth: true,
        arrows: false,
        pauseOnHover: false,
      });
    },

    /**
     * Scroll Animations
     */
    scrollAnimations: function () {
      const elements = document.querySelectorAll(".animate-obj");
      function checkScroll() {
        elements.forEach(el => {
          const rect = el.getBoundingClientRect();
          if (rect.top < window.innerHeight * 0.85) {
            el.classList.add("visible");
          }
        });
      }
      window.addEventListener("scroll", checkScroll);
      checkScroll();
    },

    /**
     * Feature Item Reveal
     
    featureReveal: function () {
      function reveal() {
        $(".feature__items , .about__wrap").each(function () {
          var $parent = $(this);
          var windowHeight = $(window).height();
          var elementTop = $parent.offset().top - $(window).scrollTop();
          var elementVisible = 150;
          if (elementTop < windowHeight - elementVisible) {
            $parent.find(".feature__item , .experience-card").each(function (index) {
              var $ele = $(this);
              setTimeout(function () {
                $ele.addClass("insight");
              }, index * 300);
            });
          }
        });
      }
      $(window).on("scroll", reveal);
      $(document).ready(reveal);
    },
*/
    /**
     * Thumb Animate
   
    thumbAnimate: function () {
      const elements = document.querySelectorAll(".slide-up");
      function checkVisibility() {
        elements.forEach(el => {
          const rect = el.getBoundingClientRect();
          const elementHeight = rect.height;
          const visibleHeight = Math.min(window.innerHeight, rect.bottom) - Math.max(0, rect.top);
          if (visibleHeight >= elementHeight * 0.4) {
            el.classList.add("in-view");
          }
        });
      }
      window.addEventListener("scroll", checkVisibility);
      checkVisibility();
    },  
    */

    /**
     * Mobile Menu
     */
    mobileMenu: function () {
      $(".header__mobi-left").on("click", function () {
        $(this).toggleClass("active");
        $(".header__mobi-menu").toggleClass('active');
        $("body").toggleClass("mobile__menu-open");
      });
    },

    /**
     * Header Sticky
     */
     headerSticky: function () {
      let lastScrollTop = 0;
      const header = document.querySelector('header');
      if (!header) return;
      window.addEventListener('scroll', function () {
        const currentScroll = window.scrollY;

        if (currentScroll > 100) {
          header.classList.add('header-sticky');
          if ($('.announcement-bar').length > 0) {
            var announcementBarHeight = $('.announcement-bar').outerHeight();
            $('.header').css('top', '-' + announcementBarHeight + 'px');
          }
        } else {
          header.classList.remove('header-sticky');
          if ($('.announcement-bar').length > 0) {
            $('.header').css('top', '0');
          }
        }
       
        if (currentScroll === 0) header.style.transform = 'translateY(0)';
        else if (currentScroll < lastScrollTop) header.style.transform = 'translateY(0)';
        else header.style.transform = 'translateY(-100%)';
        lastScrollTop = currentScroll;
      });
    },

    /**
     * Video Controls
     */
    videoControls: function () {
      var $videoWraps = $('.discover__video, .consulation__video, .backtwo__video');
      if (!$videoWraps.length) return;

      $videoWraps.each(function () {
        var $videoWrap = $(this);
        var $video = $videoWrap.find('video').get(0);
        var $source = $($video).find('source');
        var $playBtn = $videoWrap.find('.discover__video-play, .backtwo__video-play');
        var videoUnlocked = false;

        if (!$video) return;

        // preload muted (Safari-safe)
        $video.muted = true;
        $video.load();

        $playBtn.on('click', function (e) {
          e.preventDefault();

          $video.muted = false;
          $video.controls = true;

          var newSrc = $(this).find('img').data('attr');
          const currentSrc = $source.attr('src') || '';

          // Only set and load once
          if (!$video.dataset.initialized || currentSrc.trim() !== newSrc.trim()) {
            $source.attr('src', newSrc);
            $video.load();
            $video.dataset.initialized = 'true';
          }

          // Play immediately
          const playPromise = $video.play();
          if (playPromise !== undefined) {
            playPromise.catch(err => console.warn('Safari blocked playback:', err));
          }

          videoUnlocked = true;
          $playBtn.hide();
        });

        $($video).on('play pause', function () {
          if (!videoUnlocked) return;
          if ($video.paused) {
            $playBtn.show();
          } else {
            $playBtn.hide();
          }
        });
      });
    },

    /**
     * Hero Content Animation
     */
    heroContent: function () {
      const el = document.querySelector(".hero__content-wrap , .faq-hero__wrap , .about-hero__wrap");
      if (el) {
        el.classList.add("show");
      }
    },

    /**
     * Accordiyan Activation
     */
    accordiyanActivation: function () {
      $(".accordion__title").on("click", function () {
       
        var $this = $(this);
        var $content = $this.next(".accordion__content");

        if ($this.hasClass("active")) {
          $this.removeClass("active");
          $content.slideUp(300);
        } else {
          $(".accordion__content").slideUp(300);
          $(".accordion__title").removeClass("active");

          $this.addClass("active");
          $content.slideDown(300);
        }
      });

      // height recalc function
      // function adjustWrapperHeight() {
      //   if ($(window).width() > 768) {
      //     var left_height = $('.product__left').outerHeight(true);
      //     var right_height = $('.product__right').outerHeight(true);
      //     var new_height = (left_height > right_height) ? left_height : right_height;

      //     $('.product__wrapper').height(new_height);
      //   }
      // }
    },


    /**
 * Product Right Sticky Activation
 */
    /*productRightSticky: function () {
      if ($(Window).width() > 768) {
        setTimeout(function () {
          var left_height = $('.product__left').height();
          var right_height = $('.product__right').height();
          if (left_height > right_height) {
            $('.product__wrapper').height(left_height);
          }
          else {
            $('.product__wrapper').height(right_height);
          }
        }, 500); // 500 milliseconds = 5 seconds
      }
    }, */
    /**
 * Tab Activation
 */
    // tabActivation: function () {
    //   // shop tab start
    //   $(document).ready(function () {
    //     $(".collection-product__inner_tab .collection-product__tab-item").hide();
    //     $(".collection-product__inner_tab .collection-product__tab-item").first().show().addClass("active");
    //     $(".collection-product__inner_tab .tabs__items ul li").first().addClass("active");
    //     $(".collection-product__inner_tab .tabs__items ul li").on("click", function () {
    //       var type = $(this).data("type");
    //       // active class change
    //       $(".collection-product__inner_tab .tabs__items ul li").removeClass("active");
    //       $(this).addClass("active");
    //       // tab content show/hide
    //       if (type === "all") {
    //         $(".collection-product__inner_tab .collection-product__tab-item").hide().removeClass("active");
    //         $(".collection-product__inner_tab .collection-product__tab-item").show().addClass("active");
    //       } else {
    //         $(".collection-product__inner_tab .collection-product__tab-item").hide().removeClass("active");
    //         $('.collection-product__inner_tab .collection-product__tab-item[data-type="' + type + '"]').show().addClass("active");
    //       }
    //     });
    //   });
    //   // shop tab end
    // },

    /**
 * Product Popup Activation
 */
    productPopupActivation: function () {
      $(".product__zoom-icon").on("click", function () {
        // Find the current media item, excluding cloned slides
        let $current = $(".product__left-item.slick-current.slick-active:not(.slick-cloned)");
        let items = [];
        let currentIndex = 0;
        let realIndex = 0;

        // Gather all media items in the slider, excluding cloned slides
        $(".product__left-item:not(.slick-cloned)").each(function (i) {
          let $item = $(this);
          if ($item.find("img").length) {
            items.push({
              src: $item.find("img").attr("src"),
              type: "image"
            });
          } else if ($item.find("video").length) {
            let videoSrc = $item.find("video source").attr("src");
            if (videoSrc) {
              items.push({
                src: videoSrc,
                type: "video",
                video: {
                  autoplay: true,
                  controls: true,
                  loop: true,
                  muted: true
                }
              });
            }
          }
          if ($item.is($current)) {
            currentIndex = i;
          }
        });

        if (items.length) {
          Fancybox.show(items, {
            startIndex: currentIndex,
            dragToClose: false,
            closeButton: "top",
            Thumbs: false,
            Toolbar: {
              display: [
                { id: "counter", position: "center" },
                "close"
              ]
            }
          });
        }
      });
    },

    /**
     * Product Modal Activation
     */
    productModalActivation: function () {
      $(".tooltip-trigger").on('click', function () {
        $("body").addClass("modal-active");
        var modalId = $(this).data("modal-id");
        $("#" + modalId).addClass("active");
      })
      $(".guide-topbar__content a, .overlay").on('click', function () {
        $("body").removeClass("modal-active");
        $('.texture-modal').removeClass("active");
      })
      

      $(".header__cart").on('click', function () {
        $("body").addClass('cart-drawer-open');
      });
      $(".cart-drawer__close , .overlay").on('click', function () {
        $("body").removeClass('cart-drawer-open');
      });
    },


    dropdownActivation: function () {
      const dropdown = document.getElementById("dropdown");
      if (!dropdown) return; // Check if dropdown exists

      const dropdownValue = dropdown.querySelector(".dropdown-value"); // class use
      const options = dropdown.querySelectorAll(".dropdown-menu div");
      // dropdown toggle
      const selected = dropdown.querySelector(".selected");
      if (selected) {
        selected.addEventListener("click", () => {
          dropdown.classList.toggle("open");
        });
      }

      // option select
      options.forEach(option => {
        option.addEventListener("click", (e) => {
          dropdownValue.textContent = e.target.dataset.value;
          dropdown.classList.remove("open"); // dropdown off
        });
      });

      // outside click close
      document.addEventListener("click", (e) => {
        if (!dropdown.contains(e.target)) {
          dropdown.classList.remove("open");
        }
      });
    },



    dotAnimationActivation: function () {
      function handleLoading($btn, duration = 1400) {
        const $parent = $btn.parent();

        clearTimeout($parent.data("loadingTimeout"));

        $parent.addClass("loading");

        const timeoutId = setTimeout(function () {
          $parent.removeClass("loading");
        }, duration);

        $parent.data("loadingTimeout", timeoutId);
      }

      $(document).on("click", ".click-loading", function (e) {
        e.preventDefault();
        handleLoading($(this));
      });
    },

    /**
     * Lottie Signature Animation
     */
    lottieSignatureInit: function () {
      // Initialize Lottie animation when element is in view
      const lottieElements = document.querySelectorAll('.lottie-signature');
      
      lottieElements.forEach(function(lottieElement) {
        if (lottieElement && typeof lottie !== 'undefined') {
          const animationUrl = lottieElement.getAttribute('data-lottie-url');
          let animation = null;
          let isInitialized = false;
          
          // Create GSAP ScrollTrigger observer
          if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
            gsap.registerPlugin(ScrollTrigger);
            
            const scrollTrigger = ScrollTrigger.create({
              trigger: lottieElement,
              start: "top 80%",
              onEnter: function() {
                // Only load animation if not already initialized
                if (!isInitialized && animationUrl) {
                  // Clear any existing content to prevent duplicates
                  lottieElement.innerHTML = '';
                  
                  // Load and play Lottie animation
                  animation = lottie.loadAnimation({
                    container: lottieElement,
                    renderer: 'svg',
                    loop: false,
                    autoplay: true,
                    path: animationUrl
                  });
                  
                  isInitialized = true;
                  
                  // Destroy ScrollTrigger after animation starts to prevent re-triggering
                  scrollTrigger.kill();
                }
              }
            });
          }
        }
      });
    },
    /**
     * External Links Handler - Opens external links in new tabs
     */
    externalLinksHandler: function () {
      // Get current domain
      var currentHost = window.location.hostname;
      
      // Find all links on the page
      var links = document.querySelectorAll('a[href]');
      
      links.forEach(function(link) {
        var href = link.getAttribute('href');
        
        // Skip if no href or if it's a javascript: or mailto: link
        if (!href || href.indexOf('javascript:') === 0 || href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) {
          return;
        }
        
        // Skip if it's an anchor link (starts with #)
        if (href.indexOf('#') === 0) {
          return;
        }
        
        // Check if it's an external link
        var isExternal = false;
        
        try {
          var linkUrl = new URL(href, window.location.origin);
          isExternal = linkUrl.hostname !== currentHost;
        } catch (e) {
          // If URL parsing fails, treat relative URLs as internal
          isExternal = false;
        }
        
        // If it's an external link and doesn't already have target="_blank"
        if (isExternal && link.getAttribute('target') !== '_blank') {
          link.setAttribute('target', '_blank');
          link.setAttribute('rel', 'noopener noreferrer');
          
          // Add visual indicator (optional - you can remove this if not wanted)
          link.style.position = 'relative';
          
          // Add a small external link icon (optional)
          /*
          if (!link.querySelector('.external-link-icon')) {
            var icon = document.createElement('span');
            icon.className = 'external-link-icon';
            icon.innerHTML = '↗';
            icon.style.cssText = 'font-size: 0.8em; margin-left: 2px; opacity: 0.7;';
            //link.appendChild(icon);
          }*/
        }
      });
    },
    // consultationTabActivation: function (){

    // }





  };

  document.addEventListener("DOMContentLoaded", function () {
    const lazyVideos = document.querySelectorAll("video.lazy-video");

    // Utility: detect mobile
    function isMobile() {
      return typeof window !== "undefined" && (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
      );
    }

    if ("IntersectionObserver" in window) {
      const videoObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const video = entry.target;
            // If video has 'mobile-disabled' class, do NOT load it on mobile devices
            if (video.classList.contains('mobile-disabled') && isMobile()) {
              observer.unobserve(video);
              return;
            }
            const sources = JSON.parse(video.dataset.sources);

            // Append all sources
            sources.forEach(s => {
              const source = document.createElement("source");
              source.src = s.src;
              source.type = s.type;
              video.appendChild(source);
            });

            // Load video now
            video.load();
            observer.unobserve(video);
          }
        });
      });

      lazyVideos.forEach(video => videoObserver.observe(video));
    }
  });
  



  $(".tab-btn__wrap").click(function (e) {
    e.preventDefault();
    // button active class
    $(".tab-btn__wrap").removeClass("tab-active-btn");
    $(this).addClass("tab-active-btn");
    // tab content show/hide
    let target = $(this).data("tab");
    $(".booking-item").removeClass("tab-item-active");
    $("#" + target).addClass("tab-item-active");
  });

  // Script to reveal the fixed footer at the bottom of the page

  // Wait for DOM ready
  $(function () {
    var $footer = $('#shopify-section-footer');
    var $body = $('body');

    function adjustFooterAndPadding() {
      if ($footer.length) {
        // Remove any inline style that might hide it
        $footer.css('display', '');

        // Remove classes that might hide it
        $footer.removeClass('hidden d-none');

        // Fade in if hidden
        if ($footer.is(':hidden')) {
          $footer.fadeIn(400);
        }

        // Calculate footer height
        var footerHeight = $footer.outerHeight();

        // Remove any previous padding
        $body.css('padding-bottom', '');

        // Get viewport height
        var windowHeight = $(window).height();

        // If footer is taller than viewport, make it static so it scrolls with the page
        if (footerHeight >= windowHeight) {
          $footer.css({
            position: 'static',
            width: '',
            left: '',
            bottom: ''
          });
          $body.css('padding-bottom', 0);
        } else {
          // Otherwise, keep it fixed and add padding to body
          $footer.css({
            position: 'fixed',
            left: 0,
            bottom: 0,
            width: '100%'
          });
          $body.css('padding-bottom', footerHeight + 'px');
        }
      }
    }

    function updateFooterOpacity() {
      if (!$footer.length) return;
      var isAtTop = $(window).scrollTop() <= 200;
      $footer.css('opacity', isAtTop ? 0 : 1);
    }

    // Initial adjustment
    adjustFooterAndPadding();
    updateFooterOpacity();

    // Recalculate on resize and orientation change
    $(window).on('resize orientationchange', function () {
      adjustFooterAndPadding();
    });

    $(window).on('scroll', function () {
      updateFooterOpacity();
    });

    // In case images/fonts in footer load after DOM ready and change height
    var observer = new MutationObserver(function () {
      adjustFooterAndPadding();
    });
    if ($footer.length) {
      observer.observe($footer[0], { childList: true, subtree: true, attributes: true, characterData: true });
    }
  });


  // Init
  $(function () {
    amberJeanJs.m();
  });

})(jQuery, window);


$('.open-search').click(function(e){
    e.preventDefault();
    $('body').toggleClass('search-open');
});
$('.search-bar__close').click(function(e){
    $('body').removeClass('search-open');
})

$(document).ready(function () {
    $('.art-guid__tab-btn').click(function () {
        var tabID = $(this).data('tab');

        // Remove active class from all buttons
        $('.art-guid__tab-btn').removeClass('art-guid__tab-btn-active');
        // Add active class to clicked button
        $(this).addClass('art-guid__tab-btn-active');

        // Hide all tab items
        $('.art-guid__tab-item').removeClass('art-guid__tab-item-active');

        // Show the clicked tab item
        $('#' + tabID).addClass('art-guid__tab-item-active');
    });
});

$(document).ready(function () {
    try {
        var params = new URLSearchParams(window.location.search);
        var cartr = params.get('cartr');
        if (cartr && cartr.toLowerCase() === 'y') {
            $('body').addClass('cart-drawer-open');
        }
    } catch (err) {
        console.warn('URLSearchParams not supported or failed:', err);
    }
});


// scrollSmoothFaq: function () {
$("[href^='#']").click(function () {
    id = $(this).attr("href")
    $('html, body').animate({
        scrollTop: $(id).offset().top - 69
    }, 2000);
});
// },


$(".menu__sub-menu-text").on('click', function () {
    $(".menu__sub-menu-wrapper").addClass('sub-menu-active');
})
$(".menu__sub-menu-back").on('click', function () {
    $(".menu__sub-menu-wrapper").removeClass('sub-menu-active');
})



// faq-general start


if ($(window).width() > 768) {
    $(".faq-general__left ul li a").on("click", function () {
        $(".faq-general__left ul li a").removeClass("active");
        $(this).addClass("active");
    });
}



// faq-general end



if ($(Window).width() < 768) {
    $('.expect__items').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
        ]
    });
}



$(document).ready(function () {
  // Cache selectors
  var sections = $(".faq-general__item"); // all sections with an ID
  var navLinks = $(".faq-general__left li a"); // your tab elements (adjust selector)

  $(window).on("scroll", function () {
    var scrollTop = $(this).scrollTop();

    sections.each(function () {
      var sectionTop = $(this).offset().top - 300; // adjust 100px as "almost top"
      var sectionId = $(this).attr("id");

      if (scrollTop >= sectionTop) {
        // remove .active from all tabs
        navLinks.removeClass("active");
        // add .active to the tab linked to this section
        $('.faq-general__left li a[href="#' + sectionId + '"]').addClass("active");
      }
    });
  });



// Article load more
  var itemsToShow = 3;   // show first 3
  var itemsPerClick = 6; // reveal 6 more on each click

  // loop through each block
  $(".art-guid__tab-item").each(function(){
    var $block = $(this);
    var $articles = $block.find(".art-guid__bottom-post .article-post");
    var totalItems = $articles.length;

    // hide all, then show only the first 3
    $articles.hide().slice(0, itemsToShow).show();

    // button handler scoped to this block
    $block.find(".js-load-more").on("click", function(e){
      e.preventDefault();

      var visibleCount = $articles.filter(":visible").length;
      var nextCount = visibleCount + itemsPerClick;

      $articles.slice(visibleCount, nextCount).fadeIn();

      // hide button if no more items
      if(nextCount >= totalItems){
        $(this).hide();
      }
    });

    // initial check → if 3 or fewer, hide button immediately
    if(totalItems <= itemsToShow){
      $block.find(".js-load-more").hide();
    }
  });
});













 /**
     * Scroll Animations
     */
    function scrollAnimations() {
      const elements = document.querySelectorAll(".scroll-animation");
      function checkScroll() {
        elements.forEach(el => {
          const rect = el.getBoundingClientRect();
          if (rect.top < window.innerHeight * 0.85) {
            el.classList.add("visible");
          }
        });
      }
      window.addEventListener("scroll", checkScroll);
      checkScroll();
    };
    scrollAnimations();


$(document).ready(function () {
  let lastScrollTop = 0;
  const $header = $('.landing-header');
  const $hero = $('.landing-hero');
  if (!$header.length || !$hero.length) return;
  $(window).on('scroll', function () {
    const currentScroll = $(this).scrollTop();
    const heroHalf = $hero.outerHeight() / 2;
    if (currentScroll > 100) {
      $header.addClass('header-sticky');
    } else {
      $header.removeClass('header-sticky');
    }
    if (currentScroll === 0) {
      $header.css('top', '0');
    } else if (currentScroll < heroHalf) {
      $header.css('top', '-100%');
    } else if (currentScroll < lastScrollTop) {
      $header.css('top', '0');
    } else {
      $header.css('top', '-100%');
    }
    lastScrollTop = currentScroll;
  });
});






if ($(window).width() < 768) {
  $(".our-process__items").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  });
}



$(document).ready(function () {
  const $stickyBtn = $('.sticky-btn');
  const heroSection = document.querySelector('.landing-hero');
  const ctaSection = document.querySelector('.split-cta');
  let isHeroPassed = false;
  let isCtaInView = false;
  function updateStickyButton() {
    if (isHeroPassed && !isCtaInView) {
      $stickyBtn.addClass('is-visible');
    } else {
      $stickyBtn.removeClass('is-visible');
    }
  }
  const heroObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      isHeroPassed = !entry.isIntersecting;
      updateStickyButton();
    });
  }, {
    threshold: 0.1
  });
  if (heroSection) heroObserver.observe(heroSection);
  const ctaObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      isCtaInView = entry.isIntersecting;
      updateStickyButton();
    });
  }, {
    threshold: 0.1
  });
  if (ctaSection) ctaObserver.observe(ctaSection);
});